"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const warning = {
    100: '#FFFDF5',
    200: '#FEEFD2',
    300: '#FDDEA4',
    400: '#FDCB76',
    500: '#FEB647',
    600: '#FF9F18',
    700: '#DC8511',
    800: '#B96B0B',
    900: '#965307'
};
exports.default = warning;
